import React from 'react'
import './footer.css'
import { AppModalContext } from "../../components/AppModal/context";
import ContactForm from "../../components/ContactForm";

const Footer = () => {
  const { handleModal } = React.useContext(AppModalContext);
  
  return (
    <footer className="section--dark container-inner flex items-center justify-between">
      <div>© 2020 Neobility S.R.L.</div>
      <div onClick={() => handleModal(<ContactForm formType="Contactează-ne"/>)}>Contact</div>
    </footer>
  )
}

export default Footer;